/**
 * AMKA (Social Security Number) validation utilities
 * AMKA is the Greek Social Security Number consisting of 11 digits
 */

/**
 * Validates AMKA format
 * AMKA must be exactly 11 digits
 *
 * @param amka - The AMKA string to validate
 * @returns true if valid (exactly 11 digits), false otherwise
 *
 * @example
 * ```typescript
 * validateAmka('12345678901'); // true
 * validateAmka('123456789');   // false (too short)
 * validateAmka('12345678901a'); // false (contains letter)
 * ```
 */
export function validateAmka(amka: string): boolean {
  return /^\d{11}$/.test(amka);
}
